module.exports = {
    substitutions: {
        addInstructionsMessage: 'Add instructions for your personal shopper',
        addInstructionsMessageMobile: 'Personal shopper instructions',
        helpMessageToolTip:
            "You can choose to have all or part of your order substituted for items of equal or more value if any items in your order are out of stock. If you don't wish to have your items substituted you will be refunded for any out of stock items.",
        substitutionIconTooltipText: 'Substitutions',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/substitutions.js